import { defineStore } from 'pinia'
import * as apiPayments from '@/network/api/payments/payments.api.js'
import * as apiFavorites from '@/network/api/favorites.api.js'
import * as frequentsApi from '@/network/api/frequents.api.js'

export const usePaymentsServicesStore = defineStore('paymentsServicesStore', {
    state: () => ({
        paymentsOperatorsList: [],
        parsedPaymentsOperatorsListNames: [],
        favoritesList: [],
        favoritesTabs: [],
        favoritesHasMore: null,
        paymentDetail: {},
        paymentsList: [],
        frequentOperations: []
    }),
    getters: {
        getPaymentsOperatorsList: (state) => state.paymentsOperatorsList.filter(obj => obj.categoryId !== 'taxes'),
        getPaymentOperatorName: (state) => (operatorId) => {
            if (!state.parsedPaymentsOperatorsListNames.length ||
                !state.parsedPaymentsOperatorsListNames.find(payment => payment.id === parseInt(operatorId))) return operatorId
            return state.parsedPaymentsOperatorsListNames.find(payment => payment.id === parseInt(operatorId)).description
        },
        getPaymentsList: (state) => state.paymentsList,
        getFavoritesList: (state) => state.favoritesList,
        getFavoritesTabs: (state) => state.favoritesTabs,
        getFavoritesHasMore: (state) => state.favoritesHasMore,
        getPaymentDetail: (state) => state.paymentDetail,
        getFrequentOperations: (state) => state.frequentOperations
    },
    actions: {
        async paymentsOperatorsFetch(payload) {
            if (this.paymentsOperatorsList.length) return
            const res = await apiPayments.getPaymentsOperators(payload)
            if (res) {
                const data = res.data.data
                this.paymentsOperatorsList = data
                const parsedPaymentsOperatorsListNames = []
                this.paymentsOperatorsList.forEach(operatorGroups => {
                    operatorGroups.children.forEach(operator => {
                        operator.parentName = operator.name
                        operator.operatorGroupName = operatorGroups.name
                        parsedPaymentsOperatorsListNames.push(operator)
                        operator.children.forEach(elem => {
                            elem.parentName = operator.name
                            elem.operatorGroupName = operatorGroups.name
                            parsedPaymentsOperatorsListNames.push(elem)
                        })
                    })
                })
                this.parsedPaymentsOperatorsListNames = parsedPaymentsOperatorsListNames
            }
            return res
        },
        async paymentsListFetch(payload) {
            const res = await apiPayments.getPaymentsList(payload)
            if (res) {
                const data = res.data.data
                this.paymentsList = data
            }
            return res
        },
        async favoritesListFetch(payload) {
            const res = await apiFavorites.getFavoritesList(payload)
            if (res) {
                const data = res.data.data
                this.favoritesList = payload.pageNumber === 1 ? data.favorites : this.favoritesList.concat(data.favorites)
                this.favoritesHasMore = this.favoritesList.length < data.total
            }
            return res
        },
        async favoritesTabsFetch(payload) {
            const res = await apiFavorites.getFavoritesTabs(payload)
            if (res) {
                const data = res.data.data
                this.favoritesTabs = data
            }
            return res
        },
        async paymentDetailFetch(payload) {
            const res = await apiPayments.getPaymentDetail(payload)
            if (res) {
                const data = res.data.data
                this.paymentDetail = data
            }
            return res
        },
        async requestFrequentOperations(payload) {
            const res = await frequentsApi.getFrequentOperations(payload)
            if (res) this.frequentOperations = res.data.cards
            return res
        },
        async requestPaymentsDetail(payload) {
            const res = await apiPayments.getPaymentDetail(payload)
            return res
        },
        clearPaymentsServicesStates() {
            this.paymentsList = []
            this.favoritesList = []
            this.favoritesHasMore = false
            this.favoritesTabs = []
            this.paymentDetail = null
        }
    }
})
